import React from 'react'
import {
  BsArrowDownRight,
  BsGithub,
  BsLinkedin,
  BsStackOverflow,
  BsFillInfoCircleFill
} from 'react-icons/bs'
import { FaFigma, FaHome } from 'react-icons/fa'
import { GrServices } from 'react-icons/gr'
import { AiFillDollarCircle } from 'react-icons/ai'

function Footer () {
  return (
    <div className=''>
      <div className='footer flex flex-col gap-14 py-10 px-24  mt-16 bg-[#0c141d] text-white'>
        <div className='flex flex-col md:flex-row justify-between'>
          <div className='flex flex-col gap-3 pb-10'>
            <div className='top flex flex-row gap-4 items-center'>
              <div className='rounded-full bg-[#070a0e] p-[2px]'>
                <div className='circle p-3'>
                  <BsArrowDownRight className='text-white' />
                </div>
              </div>
              <h2 className='items-start text-start text-xl text-white'>
                LET'S DO SOMETHING TOGETHER 🤝
              </h2>
            </div>
            <div className=''>
              <h2 className='ml-16'>irungu1210@gmail.com</h2>
            </div>
          </div>
          <div className='flex flex-row justify-center items-center flex-wrap gap-7'>
            <li className='flex flex-row items-center gap-1'>
              <BsGithub />
              <a href='https://github.com/PurityKM'>Github</a>
            </li>
            <li className='flex flex-row items-center gap-1'>
              <BsLinkedin className='' />
              <a href='linkedin'>Linkedin</a>
            </li>
            <li className='flex flex-row items-center gap-1'>
              <FaFigma />
              <a href='figma'>Figma</a>
            </li>
            <li className='flex flex-row items-center gap-1'>
              <BsStackOverflow />
              <a href='stack'>StackOverflow</a>
            </li>
          </div>
        </div>
        <div className='flex flex-col md:flex-row justify-center items-center gap-1'>
          <p>
            &copy; <span>2024</span> PurityKM. All rights reserved.
          </p>
          <p>
            <a href='terms-of-service.html'>Terms of Service</a> |
            <a href='privacy-policy.html'>Privacy Policy</a>
          </p>
        </div>
      </div>
      <div className='menu fixed bottom-0 md:hidden w-full flex flex-row justify-between bg-[#0F1720] py-6 px-12'>
        <ul className='w-full flex flex-row justify-between'>
          <li className='list flex flex-col justify-center items-center'>
            <a className="flex flex-col justify-center items-center" href='home'>
              <FaHome className='text-white items-center text-xl' />
              <h2 className='text-[#5B62FB]'>Home</h2>
            </a>
          </li>
          <li className='flex flex-col justify-center items-center'>
            <a className="flex flex-col justify-center items-center" href='about'>
              <BsFillInfoCircleFill className='text-white text-center items-center text-xl' />
              <h2 className='text-[#5B62FB]'>About</h2>
            </a>
          </li>
          <li className='flex flex-col justify-center items-center'>
            <a className="flex flex-col justify-center items-center" href='services'>
              <GrServices className='text-white items-center text-xl' />
              <h2 className='text-[#5B62FB]'>Services</h2>
            </a>
          </li>
          <li className='flex flex-col justify-center items-center'>
            <a className="flex flex-col justify-center items-center" href='pricing'>
              <AiFillDollarCircle className='text-white items-center text-xl' />
              <h2 className='text-[#5B62FB]'>Pricing</h2>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Footer;
